module.exports = __webpack_public_path__ + "media/images/birthday-80c82193231822f19feaa1be7a70536a.jpg";